import './map_style_presets_modal.less';

import React, { Component, Fragment } from 'react';
import PropTypes from 'prop-types';

import Tooltip from 'zoomforth_component_lib/tooltip.jsx';
import Button from 'zoomforth_component_lib/button_link.jsx';
import ButtonLink from 'zoomforth_component_lib/basic_link.jsx';
import SimpleModalWithHeader from 'zoomforth_component_lib/simple_modal_with_header.jsx';

import MapStylePresetsDisplay
  from 'zoomforth_codesbane_editor/component_lib/map_style_presets_display_container.jsx';

class MapStylePresetsModal extends Component {

  constructor() {
    super();

    this.state = {
      mappedStylePresets: null
    };
  }

  render() {
    const {
      mappedStylePresets
    } = this.state;

    const {
      newThemeData,
      onRequestClose,
      onMapStylePresetsClick,
      onApplyThemeWithoutMappingClick
    } = this.props;

    return (
      <SimpleModalWithHeader
        title={
          <Fragment>
            Change Theme
            <Tooltip
              value={
                <Fragment>
                  <p>
                    Your current theme and the theme you've selected have style
                    presets. If the types of presets in your old theme are
                    associated with types of presets in your new theme, you should
                    ensure those presets are linked correctly here.
                  </p>

                  <p>
                    An example of this would be if you had, on your old theme and
                    new theme style presets like: dark-colored tiles with light
                    text and light-colored tiles with dark text. You might want to
                    ensure that the old dark-colored presets were here associated
                    with the new dark-colored presets.
                  </p>
                </Fragment>
              }
              placement="top"
            />
          </Fragment>
        }
        subtitle="Drag to reorder style presets so old presets are appropriately linked to new presets"
        className="map-style-presets-modal"
        onRequestClose={onRequestClose}
      >
        <MapStylePresetsDisplay
          newThemeData={newThemeData}
          onStylePresetMappingChange={(mappedStylePresets)=> {
            this.setState({ mappedStylePresets });
          }}
        />

        <div className="map-style-preset-actions">
          <Button
            primary
            fullwidth
            onClick={()=> {
              onMapStylePresetsClick(mappedStylePresets);
            }}
          >
            Apply theme with mapping
          </Button>

          <ButtonLink onClick={onApplyThemeWithoutMappingClick}>
            Apply theme without mapping
          </ButtonLink>
        </div>
      </SimpleModalWithHeader>
    );
  }

}

MapStylePresetsModal.propTypes = {
  onRequestClose: PropTypes.func.isRequired
};

export default MapStylePresetsModal;
